var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AppHeader',{attrs:{"title":"하이모 소식"}}),_c('AppContent',[_c('PromotionList')],1),_c('AppFooter')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }